<template>

<div class="game">

    <core-gamename :game="item.game" :collection="item.collection" class="game-name" />

	<div class="game-version" v-if="showVersion">{{ version }}</div> 

    <app-view-common-tags :field="field" :item="item" :filter="filter" :is-condensed="isCondensed" v-if="showTags" />

	<app-view-common-owners :field="field" :item="item" v-if="!isUser && field.owners === 'enabled' && statuses === 1 && !isCondensed" />

    <app-view-common-awards :field="field" :item="item" :filter="filter" :is-condensed="isCondensed" v-if="showAwards" />

</div>

</template>

<script>

export default {

	props: ['field', 'item', 'filter', 'isCondensed', 'isSticky'],

	computed: {

        showVersion: function() {

            return this.field.version === 'enabled'

        },

        showTags: function() {

            return this.field.tags === 'enabled'

        },

        showAwards: function() {

            return this.field.awards === 'enabled'

        },

		statuses: function() {

			return this.$store.getters['filter/' + this.filter + '/status/active'].length

		},

		version: function() {

			if (this.item.game.version) {

				var version = ''
				
				version += this.item.game.version.name + ((this.item.game.version.year) ? ' (' + this.item.game.version.year + ')' : '')

				return version

			} else {

				return ''

			}

		}

    }

}

</script>

<style scoped>

.game {
    padding-top: 10px;
}

.game-name {
	color: #333;
	font-weight: 500;
	font-size: 16px;
	line-height: 16px;
	min-width: 0;
    display: block;
    max-width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    overflow: hidden;
}

.field.is-condensed .game-name {
	font-size: 14px;
	line-height: 14px;
}

.is-desktop .game-name:hover {
	text-decoration: underline;
}

.game-version {
	color: #666;
	font-size: 11px;
	margin-top: 2px;
	line-height: 11px;
	font-weight: 400;
}

</style>